import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";

function SubscriptionForm({ data, closeModal }) {
  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);
  return (
    <div className="bg-black bg-opacity-20 w-full h-screen overflow-y-auto fixed top-0 left-0 bottom-0 z-[999] grid place-items-center p-4 fade-in" onClick={() => closeModal()}>
      <div className="bg-white max-w-3xl p-12 rounded-2xl relative fade-in-down" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => closeModal()} className="absolute top-6 right-6">
          <RxCross2 className="text-[#774d96] text-lg" />
        </button>
        <div className="max-w-md w-full">
          <h1 className="text-[2rem] font-medium">{data.subscription}</h1>
          <p className="text-[10px] font-light mt-2">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <form
            action=""
            className="mt-4 space-y-4"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="space-y-5">
              <input
                type="text"
                placeholder="Name"
                className="px-4 py-2 border rounded font-light w-full"
              />
              <input
                type="text"
                placeholder="Phone"
                className="px-4 py-2 border rounded font-light w-full"
              />
              <input
                type="text"
                placeholder="Email"
                className="px-4 py-2 border rounded font-light w-full"
              />
              <input
                type="text"
                placeholder="Amount"
                className="px-4 py-2 border rounded font-light w-full"
              />
            </div>
            <div className="w-full space-y-4">
              <span className="flex gap-4 text-xs">
                <h5 className="text-[#774d96]">Amount: </h5>
                <p>{data.price}</p>
              </span>
              <span className="flex gap-4 text-xs">
                <h5 className="text-[#774d96]">Expire Days: </h5>
                <p>{data.expiry}</p>
              </span>
              <span className="flex gap-4 text-xs">
                <h5 className="text-[#774d96]">Package Details: </h5>
                <p>{data.details}</p>
              </span>
            </div>
            <hr />
            <div className="w-full text-start">
              <h4 className="text-lg font-medium">Select Payment</h4>
              <span className="flex items-center gap-2">
                <input type="radio" name="cash" id="cash" />
                <label htmlFor="cash" className="text-xs">
                  Cash
                </label>
              </span>
            </div>
            <button className="bg-[#5C1895] text-white max-w-[8rem] w-full px-2 py-1 rounded mx-auto">
              Pay Now
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function SubscriptionCard({ data }) {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);
  return (
    <div className="rounded overflow-hidden border border-[#7B20C7] font-medium text-center max-w-[30rem] w-full">
      <div className="bg-[#7B20C7] py-4 px-2">
        <h4 className="text-white text-xl">{data.subscription}</h4>
      </div>
      <div className="text-center py-4 px-2 grid gap-2">
        <p className="text-2xl">Price - {data.price} SAR</p>
        <p className="text-lg">Delivery Charges - {data.deliveryCharges} SAR</p>
        <p className="text-lg">Discount - {data.discount}%</p>
        <p className="text-lg">
          Total Meal Quantity - {data.totalMealQuantity}
        </p>
        <p className="text-lg text-[#7B20C7]">On Below Categories</p>
        {data.categories.map((cat, index) => (
          <p key={index} className="text-lg font-bold">
            {cat}
          </p>
        ))}
        <p className="text-lg">{data.details}</p>
        <button
          onClick={toggleModal}
          className="bg-[#5C1895] text-white max-w-[18rem] w-full px-2 py-1 rounded mx-auto mt-4"
        >
          Subscribe Now
        </button>
      </div>
      {showModal && <SubscriptionForm data={data} closeModal={toggleModal} />}
    </div>
  );
}

export default SubscriptionCard;
